export default "__VITE_ASSET__CeEhnTGW__"